import React from 'react';

interface DisclaimerProps {
    type?: 'investment' | 'simulation' | 'general';
    compact?: boolean;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ type = 'investment', compact = false }) => {
    const messages = {
        investment: {
            icon: '⚠️',
            title: 'Avertissement',
            text: 'Les informations présentées sont à titre informatif uniquement et ne constituent pas des conseils en investissement. Toute décision d\'investissement reste de votre seule responsabilité.',
        },
        simulation: {
            icon: '🎮',
            title: 'Portefeuille Virtuel',
            text: 'Ce portefeuille est une simulation à but éducatif. Les transactions n\'impliquent aucun mouvement de fonds réels.',
        },
        general: {
            icon: 'ℹ️',
            title: 'Information',
            text: 'Les données affichées proviennent de sources considérées comme fiables mais leur exactitude ne peut être garantie.',
        },
    };

    const msg = messages[type];

    if (compact) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 14px',
                background: type === 'investment' ? '#fef3c7' : type === 'simulation' ? '#dbeafe' : '#f1f5f9',
                borderRadius: '8px',
                fontSize: '12px',
                color: type === 'investment' ? '#92400e' : type === 'simulation' ? '#1e40af' : '#475569',
            }}>
                <span>{msg.icon}</span>
                <span>{msg.text}</span>
            </div>
        );
    }

    return (
        <div style={{
            padding: '16px 20px',
            background: type === 'investment' ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)' :
                type === 'simulation' ? 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)' : '#f8fafc',
            borderRadius: '12px',
            border: type === 'investment' ? '1px solid #fbbf24' :
                type === 'simulation' ? '1px solid #60a5fa' : '1px solid #e2e8f0',
            marginBottom: '20px',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
            }}>
                <span style={{ fontSize: '24px' }}>{msg.icon}</span>
                <div>
                    <div style={{
                        fontWeight: '600',
                        fontSize: '14px',
                        color: type === 'investment' ? '#92400e' : type === 'simulation' ? '#1e40af' : '#334155',
                        marginBottom: '4px',
                    }}>
                        {msg.title}
                    </div>
                    <div style={{
                        fontSize: '13px',
                        color: type === 'investment' ? '#a16207' : type === 'simulation' ? '#1d4ed8' : '#64748b',
                        lineHeight: '1.5',
                    }}>
                        {msg.text}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Disclaimer;
